import {
  isObject,
  getObjectByName,
} from './object';

export const toCamelCase = (str) => String(str).replace(/-([a-z])/g, (all, match) => match.toUpperCase());

export const toSelectorCase = (str) => String(str).replace(/([A-Z])/g, '-$1').toLowerCase();

export const startsWith = (str, prefix) => str.lastIndexOf(prefix, 0) === 0;

export const replaceParameters = (str, optParams, optNotFound) => {
  if (optParams && (Array.isArray(optParams) || typeof optParams === 'object')) {
    const re = new RegExp('\\$?((\\{)|(%7B))(.*?)((\\})|(%7D))', 'g');
    const paramsInStr = str.match(re);
    if (paramsInStr) {
      // eslint-disable-next-line
      for (const i in paramsInStr) {
        const key = paramsInStr[i];
        const clearKey = key.toString().replace(re, '$4');
        const value = getObjectByName(clearKey, optParams);
        const newValue = value != null ? value : optNotFound || key;
        str = str.replace(key, newValue);
      }
    }
  }
  return str;
};

export const isString = (val) => typeof val === 'string';

/**
 * @param {string} type
 * @param {Array|Object=} optValues
 * @param {string=} optPrefix
 * @param {Object=} optMessages
 * @return {string}
 */
export const i18n = (type, optValues, optPrefix, optMessages) => {
  let values = optValues || {};
  const messages = optMessages || {};
  const computedType = (
    optPrefix
  ) ? `${optPrefix}.${type}` : type;
  let str;
  let hasMessage = true;

  if (messages[computedType]) {
    str = messages[computedType];
  } else if (messages[type] != null) {
    str = messages[type];
  } else {
    if (window.clientMessages && window.clientMessages[computedType]) {
      str = window.clientMessages[computedType];
    } else if (window.clientMessages && window.clientMessages[type]) {
      str = window.clientMessages[type];
    } else {
      str = `!!!.${computedType}.!!!`;
      hasMessage = false;
    }
  }
  if (hasMessage) {
    // message může být i object {"title": "obsah message", "param": string|Array.<string>}
    if (isObject(str)) {
      values = str.param ? (
        isString(str.param) ? [str.param] : str.param
      ) : [];
      str = str.title;
    }
    // eslint-disable-next-line
    for (const key in values) {
      // eslint-disable-next-line
      const value = ('' + values[key]).replace(/\$/g, '$$$$');
      // eslint-disable-next-line
      str = str.replace(new RegExp('\\$\\{' + key + '\\}', 'gi'), value);
    }
  } else {
    // eslint-disable-next-line
    for (const key in values) {
      // eslint-disable-next-line
      str += '${' + key + '}';
    }
  }
  return str;
};




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/lib/string.js